<template>
  <div style="background-color: #f6f6f6;">
    <van-nav-bar title="邀请有奖" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <img src="@/assets/fenxiang.jpg" style="width:100%" v-on:click="$router.push('/user/yaoqing')" />

    <div style="height:46px"></div>
    <TabBar active="4" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
export default {
  name: "fenxiangIndex",
  components: {
    TabBar
  },
  date() {
    return {
      user: { token: "" }
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getShareId() {
      this.$http
        .get(
          this.GLOBAL.API + "s_user/share/check",

          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          if(data.code==1){
              this.$toast('您已经是分享师了');
              setTimeout(() => {
                  this.$router.push('/qiang/list');
              }, 1500);
          }
        });
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.getShareId();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>